var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Model as DataModel } from '@/models/Model';
import { InstanceLoader } from '@/support/InstanceLoader';
let SelectFilter = class SelectFilter extends Vue {
    constructor() {
        super(...arguments);
        this.Model = new DataModel();
        this.options = [];
        this.isLoading = false;
        this.selected = null;
    }
    get filters() {
        return this.$store.state.filters;
    }
    mounted() {
        if (this.type in this.$store.state.filters) {
            this.options = this.$store.state.filters[this.type];
            this.setDefault();
            return;
        }
        this.getOptions();
    }
    setSelected(values) {
        this.selected = values;
    }
    getOptions() {
        if (this.type in this.$store.state.filters && this.isLoading == false) {
            this.options = this.$store.state.filters[this.type];
            return;
        }
        const payload = {};
        payload[this.type] = [];
        this.$store.dispatch('updateFilters', payload);
        this.Model = InstanceLoader.get(this.type);
        this.Model
            .limit(1000)
            .sort(this.sort)
            .all()
            .then((items) => {
            const mutatedPeriods = [];
            items.forEach((item) => {
                mutatedPeriods.push({
                    value: item.id,
                    text: this.translate ? this.translateOptionText(item.getFilterLabel()) : item.getFilterLabel(),
                });
            });
            const payload = {};
            payload[this.type] = mutatedPeriods;
            this.$store.dispatch('updateFilters', payload);
            this.options = mutatedPeriods;
            this.setDefault();
            this.isLoading = false;
        })
            .catch(() => {
            /**/
        });
    }
    translateOptionText(text) {
        return this.$t(`select_filter.${text}`).toString();
    }
    get typePlaceholder() {
        switch (this.type) {
            case 'Level':
                return this.$tc('component.selectFilter.level');
            case 'SubjectLabel':
                return this.$tc('component.selectFilter.subject_label');
            default:
                return this.$tc('component.selectFilter.period');
        }
    }
    resetValues(reset) {
        if (reset) {
            this.$nextTick(() => {
                this.selected = this.default;
                this.$emit('select-reset');
            });
        }
    }
    optionSelected(value, oldValue) {
        if (value !== oldValue) {
            if (this.returnObject) {
                this.$emit('input', { value, type: this.type });
            }
            else {
                this.$emit('input', value);
            }
        }
    }
    itemsSelected(value, oldValue) {
        this.selected = this.selectedItems;
    }
    onStateChanged(value, oldValue) {
        if (this.type in this.$store.state.filters) {
            this.options = this.$store.state.filters[this.type];
            return;
        }
    }
    setDefault() {
        if (this.default !== null && this.default !== undefined && this.default.length > 0 && this.selected === null && this.selected !== this.default) {
            this.selected = this.default;
        }
        if (this.defaultMultiple !== null && this.defaultMultiple !== undefined && this.defaultMultiple.length > 0 && this.selected === null && this.selected !== this.defaultMultiple) {
            this.selected = this.defaultMultiple;
        }
    }
    clearSelect(clear) {
        if (clear) {
            this.$nextTick(() => {
                this.selected = '';
            });
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Array)
], SelectFilter.prototype, "selectedItems", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], SelectFilter.prototype, "hideDetails", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], SelectFilter.prototype, "disabled", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], SelectFilter.prototype, "default", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], SelectFilter.prototype, "defaultMultiple", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], SelectFilter.prototype, "reset", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], SelectFilter.prototype, "returnObject", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], SelectFilter.prototype, "clear", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], SelectFilter.prototype, "translate", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], SelectFilter.prototype, "type", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], SelectFilter.prototype, "sort", void 0);
__decorate([
    Prop({ default: undefined }),
    __metadata("design:type", Boolean)
], SelectFilter.prototype, "multiple", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], SelectFilter.prototype, "placeholder", void 0);
__decorate([
    Watch('reset'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SelectFilter.prototype, "resetValues", null);
__decorate([
    Watch('selected'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], SelectFilter.prototype, "optionSelected", null);
__decorate([
    Watch('selectedItems'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], SelectFilter.prototype, "itemsSelected", null);
__decorate([
    Watch('filters'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], SelectFilter.prototype, "onStateChanged", null);
__decorate([
    Watch('clear'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SelectFilter.prototype, "clearSelect", null);
SelectFilter = __decorate([
    Component
], SelectFilter);
export default SelectFilter;
